import axiosInstance from "./axios";

export const fetchCities = () => {
  return axiosInstance.get("/cities");
};

export const fetchCitiesByZone = (zoneId) => {
  return axiosInstance.get(`/cities/by-zone/${zoneId}`);
};

// Paginated + searchable cities (optionally scoped to a zone), used by the
// async CitySelect dropdown.
export const searchCities = ({ page = 1, perPage = 50, search = "", zoneId = null } = {}) => {
  return axiosInstance.get("/cities", {
    params: {
      page,
      per_page: perPage,
      search: search || undefined,
      zone_id: zoneId || undefined,
    },
  });
};

export const fetchCityById = (id) => {
  return axiosInstance.get(`/cities/${id}`);
};

export const createCity = (cityData) => {
  return axiosInstance.post("/cities", cityData);
};

export const updateCity = (id, cityData) => {
  return axiosInstance.put(`/cities/${id}`, cityData);
};

export const deleteCity = (id) => {
  return axiosInstance.delete(`/cities/${id}`);
};
